import React, { ReactElement, ReactNode } from 'react';
import { Popover } from 'common/components/antd/Popover/Popover';
import { SContainer } from './FilterPopover.style';

type FilterPopoverProps = {
  content: ReactNode;
  children: ReactNode;
  open: boolean;
  onOpenChange?: (newOpen: boolean) => void;
};

const FilterPopover = ({ content, children, open, onOpenChange }: FilterPopoverProps): ReactElement => (
  <Popover
    open={open}
    placement="bottomRight"
    trigger="click"
    content={<SContainer>{content}</SContainer>}
    onOpenChange={onOpenChange}
  >
    {children}
  </Popover>
);

export { FilterPopover };
